export class NavigationStateKeys {
    public static readonly remoteLogout = 'remoteLogout';
}
